import { useEffect, useState } from 'react';
import { getPersonalizedMelioIntelligenceFeed } from '../services/melioIntelligenceService';
import { MelioIntelligenceContext, PersonalizedMelioIntelligenceItem } from '../types/melioIntelligence';

export default function useMelioIntelligence(context: MelioIntelligenceContext | null) {
  const [loading, setLoading] = useState(Boolean(context));
  const [items, setItems] = useState<PersonalizedMelioIntelligenceItem[]>([]);

  useEffect(() => {
    const load = async () => {
      if (!context) {
        setItems([]);
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const nextItems = await getPersonalizedMelioIntelligenceFeed(context);
        setItems(nextItems);
      } catch (error) {
        console.error('Error loading Melio Intelligence feed:', error);
        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [context]);

  return {
    loading,
    items,
    featuredItem: items[0] || null,
  };
}
